// extracted by mini-css-extract-plugin
export default {"container":"GroupsFilter_container__gSC70"};